// employee/reducers.ts
const initialState = {
    getExpensesData: [],
    createExpensesData: null,
    updateExpensesData: null,
    getExpensesCount: null,
    getExpensesMetaMessage: null,
    getExpensesSuccess: false,
    getExpensesFailure: false,
    createExpensesSuccess: false,
    createExpensesFailure: false,
    updateExpensesSuccess: false,
    updateExpensesFailure: false,
    deleteExpensesSuccess: false,
    deleteExpensesFailure: false,
};

export default function ExpensesReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_EXPENSES_SUCCESS': {
            return {
                ...state,
                getExpensesSuccess: true,
                getExpensesData: action.payload?.data?.data?.data,
                getExpensesCount:action.payload?.data?.data?.meta?.total,
                getExpensesFailure: false,
            };
        }
        case 'GET_EXPENSES_FAILURE': {
            return {
                ...state,
                getExpensesFailure: true,
                getExpensesMetaMessage: action.payload?.data?.data?.meta?.message,
                getExpensesSuccess: false,
            };
        }
        case 'RESET_GET_EXPENSES': {
            return {
                ...state,
                getExpensesSuccess: false,
                getExpensesFailure: false,
                getExpensesData: [],
                getExpensesMetaMessage: null,
            };
        }

        case 'CREATE_EXPENSES_SUCCESS': {
            return {
                ...state,
                createExpensesSuccess: true,
                createExpensesData: action.payload?.data?.data?.data,
                getExpensesMetaMessage: action.payload?.data?.data?.meta?.message,
                createExpensesFailure: false,
            };
        }
        case 'CREATE_EXPENSES_FAILURE': {
            return {
                ...state,
                createExpensesFailure: true,
                getExpensesMetaMessage: action.payload?.data?.data?.meta?.message,
                createExpensesSuccess: false,
            };
        }
        case 'RESET_CREATE_EXPENSES': {
            return {
                ...state,
                createExpensesSuccess: false,
                createExpensesFailure: false,
                createExpensesData: null,
                getExpensesMetaMessage: null,
            };
        }

        case 'UPDATE_EXPENSES_SUCCESS': {
            return {
                ...state,
                updateExpensesSuccess: true,
                updateExpensesData: action.payload?.data?.data?.data,
                getExpensesMetaMessage: action.payload?.data?.data?.meta?.message,
                updateExpensesFailure: false,
            };
        }
        case 'UPDATE_EXPENSES_FAILURE': {
            return {
                ...state,
                updateExpensesFailure: true,
                getExpensesMetaMessage: action.payload?.data?.data?.meta?.message,
                updateExpensesSuccess: false,
            };
        }
        case 'RESET_UPDATE_EXPENSES': {
            return {
                ...state,
                updateExpensesSuccess: false,
                updateExpensesFailure: false,
                updateExpensesData: null,
                getExpensesMetaMessage: null,
            };
        }

        case 'DELETE_EXPENSES_SUCCESS': {
            return {
                ...state,
                deleteExpensesSuccess: true,
                getExpensesMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteExpensesFailure: false,
            };
        }
        case 'DELETE_EXPENSES_FAILURE': {
            return {
                ...state,
                deleteExpensesFailure: true,
                getExpensesMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteExpensesSuccess: false,
            };
        }
        case 'RESET_DELETE_EXPENSES': {
            return {
                ...state,
                deleteExpensesSuccess: false,
                deleteExpensesFailure: false,
                getExpensesMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
